// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Tp-z","breadcrumbForward":"Up-z","breadcrumbBack":"Vp-z","selected":"Wp-z"};